import type { FaireProductEntity } from "../../entity_types/product";

export const p_kgp4svkrra: FaireProductEntity = {
  token: "p_kgp4svkrra",
  type: "product",
  name: "Precious Gems & Crystals 11 oz Ceramic Mug",
  brandToken: "b_ihxgqwki5y",
  brandName: "Atlas Screen Printing",
  imageUrl:
    "https://cdn.faire.com/fastly/c646ed874974146cf55595bbe460092f7b5f4f2d61db8cd3558c1758cc0528eb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6ffd1b861f63df3284b70605c25dc40f30ecb4305c2aa2fa51eeee5400c519fe.jpeg",
  ],
  priceDollars: 6.24,
  description:
    "Our WILD COTTON® 11 oz Ceramic Mug is made from high-quality ceramic and is built to last. Decorated with our original are makes this a unique gift. Ideal for everyday use with your favorite coffee, tea, or any drink.",
  tags: [],
  msrpDollars: 12.47,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:49.665Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
